const reportsPage = {
  report: 'Informes',
};

export default reportsPage;
